var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoReloj(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1645_9114)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M5.38462 0.515625C4.78894 0.515625 4.30769 0.99043 4.30769 1.57812C4.30769 2.16582 4.78894 2.64062 5.38462 2.64062H5.92308V3.78281C2.56779 4.29414 0 7.15625 0 10.6094C0 14.4244 3.13317 17.5156 7 17.5156C10.8668 17.5156 14 14.4244 14 10.6094C14 9.22148 13.5861 7.92988 12.8726 6.85078L13.6837 6.05059C14.1043 5.63555 14.1043 4.96152 13.6837 4.54648C13.263 4.13145 12.5798 4.13145 12.1591 4.54648L11.4322 5.26367C10.4865 4.5 9.33894 3.97539 8.07692 3.78281V2.64062H8.61539C9.21106 2.64062 9.69231 2.16582 9.69231 1.57812C9.69231 0.99043 9.21106 0.515625 8.61539 0.515625H7H5.38462ZM7.80769 6.89062V11.1406C7.80769 11.5822 7.4476 11.9375 7 11.9375C6.5524 11.9375 6.19231 11.5822 6.19231 11.1406V6.89062C6.19231 6.44902 6.5524 6.09375 7 6.09375C7.4476 6.09375 7.80769 6.44902 7.80769 6.89062Z",
    fill: "url(#paint0_linear_1645_9114)",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1645_9114",
    x1: 14.8027,
    y1: -0.489301,
    x2: 9.5117,
    y2: 19.9749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47297F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832A89"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1645_9114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 17,
    fill: "white",
    transform: "translate(0 0.515625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoReloj);
export default __webpack_public_path__ + "static/media/icono-reloj.ba6ae37eec876eb283bd038307d494b7.svg";
export { ForwardRef as ReactComponent };